import { gql } from "@apollo/client";

export default {};

export const getParentAircraftTypes = gql`
    query GetParentAircraftTypes {
        getParentAircraftTypes {
            id
            label
            name
            sort_order
        }
    }
`;

export const getAirportsLike = gql`
    query GetAirportsLike($input: String!, $limit: Int) {
        getAirportsLike(input: $input, limit: $limit) {
            airport_code
        }
    }
`;

export const getUserQuery = gql`
    query currentLegacyUser {
        currentLegacyUser {
            id
            first_name
            last_name
        }
    }
`;

export const getDuty = gql`
    query GetDuty($personId: Int!, $date: Date!) {
        getDuty(person_id: $personId, date: $date) {
            id
            person_id
            entry_date
            DutyItems {
                id
                duty_id
                aircraft_type_id
                duty_type_id
                duty_start
                location_start
                duty_end
                location_end
                flight_time
                AircraftType {
                    id
                    label
                    name
                    sort_order
                }
                ItemAttributes {
                    id
                    duty_item_id
                    duty_attr_type_id
                    value
                    DutyAttrType {
                        id
                        attr
                        label
                    }
                }
            }
        }
    }
`;

export const getDutyTypes = gql`
    query GetDutyTypes {
        getDutyTypes {
            id
            label
        }
    }
`;

export const CREATE_OR_UPDATE_PILOT_DUTY = gql`
    mutation CreateOrUpdatePilotDuty($input: PilotDutyInput!) {
        createOrUpdateDuty(input: $input) {
            id
            person_id
            entry_date
            DutyItems {
                id
                duty_id
                aircraft_type_id
                duty_type_id
                duty_start
                location_start
                duty_end
                location_end
                flight_time
                AircraftType {
                    id
                    label
                    name
                    sort_order
                }
                ItemAttributes {
                    id
                    duty_item_id
                    duty_attr_type_id
                    value
                    DutyAttrType {
                        id
                        attr
                        label
                    }
                }
            }
        }
    }
`;

export const DELETE_PILOT_DUTY_BY_ID = gql`
    mutation DeleteDutyById($deleteDutyByIdId: Int!) {
        deleteDutyById(id: $deleteDutyByIdId)
    }
`;

export const getNightCurrencyByPersonAndDate = gql`
    query GetNightCurrencyByPersonAndDate($personId: Int!, $date: DateTime!) {
        getNightCurrencyByPersonAndDate(person_id: $personId, date: $date) {
            totals {
                night_takeoff
                night_landing
            }
            expirations {
                expiry
            }
        }
    }
`;

export const getIfrCurrencyByPersonAndDate = gql`
    query GetIfrCurrencyByPersonAndDate($personId: Int!, $date: DateTime!) {
        getIfrCurrencyByPersonAndDate(person_id: $personId, date: $date) {
            totals {
                ifr_hours
                ifr_approaches
            }
            expirations {
                expiry
            }
        }
    }
`;

export const getTolCurrencyByPersonAndDate = gql`
    query GetTolCurrencyByPersonAndDate($personId: Int!, $date: DateTime!) {
        getTolCurrencyByPersonAndDate(person_id: $personId, date: $date) {
            totals {
                aircraft_type_id
                aircraft_type
                total_takeoff
                total_landing
            }
            expirations {
                aircraft_type_id
                period
                expiry
            }
        }
    }
`;

export const getDutyTimesSummary = gql`
    query GetDutyTimesSummary($personId: Int!, $date: DateTime!) {
        getDutyTimesSummary(person_id: $personId, date: $date) {
            sections {
                section {
                    id
                    node_id
                    sort_order
                    label
                    rows {
                        id
                        node_id
                        section_id
                        label
                        requirement
                        sort_order
                        indent_level
                        period
                        period_units
                        limit_in_period {
                            type
                            period
                            period_units
                            limit
                            limit_units
                            condition
                            threshold_percent
                        }
                        value {
                            row_id
                            value
                            alert_level
                        }
                        single_pilot
                        visible
                    }
                }
            }
        }
    }
`;

export const getComments = gql`
    query GetComments($commentableModel: String!, $commentableId: Int!) {
        getComments(commentable_model: $commentableModel, commentable_id: $commentableId) {
            id
            commentable_model
            commentable_id
            comment
        }
    }
`;

export const CREATE_OR_UPDATE_COMMENT = gql`
    mutation CreateOrUpdateComment($comment: CommentInput) {
        createOrUpdateComment(comment: $comment) {
            id
            commentable_model
            commentable_id
            comment
        }
    }
`;

export const DELETE_COMMENT_BY_ID = gql`
    mutation DeleteCommentById($deleteCommentByIdId: Int!) {
        deleteCommentById(id: $deleteCommentByIdId)
    }
`;
